import { isNil } from 'lodash';
import { DEFAULT_POLYGON_PROPS } from '../../../../../Shape/config/Shapes';

const getSides = shape => (isNil(shape.get('sides')) ? DEFAULT_POLYGON_PROPS.sides : shape.get('sides'));

export default getSides;
